import { render, staticRenderFns } from "./clip.vue?vue&type=template&id=dbb0f464&"
import script from "./clip.vue?vue&type=script&lang=js&"
export * from "./clip.vue?vue&type=script&lang=js&"
import style0 from "./clip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports